import React from 'react';
import { Loader } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

/**
 * Reusable Action Card Component
 * Displays an action with icon, description, and button
 */
const ActionCard = ({ 
  icon: Icon, 
  title, 
  description, 
  buttonText, 
  buttonIcon: ButtonIcon,
  onClick, 
  loading, 
  loadingText,
  accentColor = 'var(--accent-gold)',
  children 
}) => {
  return (
    <Card className="premium-card p-6">
      <div className="flex items-start gap-4 mb-4">
        <div 
          className="w-12 h-12 rounded-full flex items-center justify-center"
          style={{ backgroundColor: `${accentColor}15` }}
        >
          <Icon className="w-6 h-6" style={{ color: accentColor }} />
        </div>
        <div className="flex-1">
          <h3 className="heading-md mb-2">{title}</h3>
          <p className="text-sm mb-4" style={{ color: 'var(--text-grey)' }}>
            {description}
          </p>
          <Button
            onClick={onClick}
            disabled={loading}
            className="premium-button w-full flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader className="w-4 h-4 animate-spin" />
                {loadingText}
              </>
            ) : (
              <>
                {ButtonIcon && <ButtonIcon className="w-4 h-4" />}
                {buttonText}
              </>
            )}
          </Button>
        </div>
      </div>
      {children}
    </Card>
  );
};

export default ActionCard;
